import { render, staticRenderFns } from "./Replay.vue?vue&type=template&id=3998faa0&"
import script from "./Replay.vue?vue&type=script&lang=js&"
export * from "./Replay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Replay.vue"
export default component.exports